import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["className", "children"];
import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import styles from "./SideBody.module.css";
export var SideBody = React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded),
    classes = cx(styles.sideBody, className);
  return React.createElement("section", _extends({
    className: classes,
    tabIndex: 0,
    role: "tabpanel",
    ref: ref
  }, rest), children);
});
var sideBodyPropTypes = {
  className: PropTypes.string,
  id: PropTypes.string.isRequired
};
SideBody.propTypes = sideBodyPropTypes, SideBody.__docgenInfo = {
  description: "The `SideBody` component is designed as a container for Icon tabs\n\n@metadataType container",
  methods: [],
  displayName: "SideBody",
  props: {
    className: {
      type: {
        name: "string"
      },
      required: !1,
      description: "Additional class names for component."
    },
    id: {
      type: {
        name: "string"
      },
      required: !0,
      description: "Side id"
    }
  }
};